import { useEffect, useState } from 'react';

export const useCountdownTimer = (timeToFinish: number) => {
  const [totalSecondsRemaining, setTotalSecondsRemaining] = useState(
    getTotalSecondsRemaining(timeToFinish, Date.now())
  );

  const minutesRemaining = getMinutesRemaining(totalSecondsRemaining);
  const secondsRemaining = getSecondsRemaining(
    totalSecondsRemaining,
    minutesRemaining
  );

  useEffect(() => {
    setTotalSecondsRemaining(
      getTotalSecondsRemaining(timeToFinish, Date.now())
    );

    const interval = setInterval(() => {
      setTotalSecondsRemaining(
        getTotalSecondsRemaining(timeToFinish, Date.now())
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [timeToFinish]);

  return {
    secondsRemaining: secondsRemaining.toString().padStart(2, '0'),
    minutesRemaining: minutesRemaining.toString().padStart(2, '0'),
    totalSecondsRemaining,
  };
};

const getTotalSecondsRemaining = (
  timeToFinish: number,
  currentTime: number
) => {
  const result = Math.floor((timeToFinish - currentTime) / 1000);
  if (result < 0) return 0;

  return result;
};

const getMinutesRemaining = (totalSecondsRemaining: number) => {
  return Math.floor(totalSecondsRemaining / 60);
};

const getSecondsRemaining = (
  totalSecondsRemaining: number,
  minutesRemaining: number
) => {
  if (totalSecondsRemaining < 60) return totalSecondsRemaining;

  return totalSecondsRemaining - minutesRemaining * 60;
};
